import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError, IFetchPayload } from "../../../interfaces/base";
import { IFetchAltExercisesState } from "../../../interfaces/store/exercise-interface";

const initialState: IFetchAltExercisesState = {
  exercises: [],
  chosenExercises: [],
  loading: false,
  error: null,
  requestState: "prepare",
  operation: null,
};

const _fetchExercisesStart = (
  state: IFetchAltExercisesState,
  { payload }: PayloadAction<IFetchPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
};

const _fetchExercisesSuccess = (
  state: IFetchAltExercisesState,
  { payload }: PayloadAction<any>
) => {
  state.exercises = payload.data.data;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _fetchExercisesFailed = (
  state: IFetchAltExercisesState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _fetchChosenExercisesStart = (
  state: IFetchAltExercisesState,
  { payload }: PayloadAction<{ exercisesIds: string[] }>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
};

const _fetchChosenExercisesSuccess = (
  state: IFetchAltExercisesState,
  { payload }: PayloadAction<any>
) => {
  state.chosenExercises = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _fetchChosenExercisesFailed = (
  state: IFetchAltExercisesState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetExercises = () => {
  return { ...initialState };
};

const AltExercisesSlice = createSlice({
  name: "alt-exercises",
  initialState,
  reducers: {
    fetchExercisesStart: _fetchExercisesStart,
    fetchExercisesSuccess: _fetchExercisesSuccess,
    fetchExercisesFailed: _fetchExercisesFailed,
    resetExercises: _resetExercises,
    fetchChosenExercisesStart: _fetchChosenExercisesStart,
    fetchChosenExercisesSuccess: _fetchChosenExercisesSuccess,
    fetchChosenExercisesFailed: _fetchChosenExercisesFailed,
  },
});

export const {
  fetchExercisesStart,
  fetchExercisesSuccess,
  fetchExercisesFailed,
  resetExercises,
  fetchChosenExercisesStart,
  fetchChosenExercisesSuccess,
  fetchChosenExercisesFailed,
} = AltExercisesSlice.actions;
export default AltExercisesSlice.reducer;
